<template>
  <div>
    <iframe class="iframe_content" :src="url" frameborder="0"></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: '',
    };
  },
  mounted() {
    this.url = 'https://c-h5.didi-food.com/user-guide/terms';
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-family: 'Aspira Light';
  font-weight: 200;
  font-size: 12px;
  margin-top: 8px;
  cursor: pointer;
}
</style>